import React, { forwardRef } from 'react'
import { domain } from '../urls'

const ComponentToPrint = forwardRef(({ item }, ref) => (
    <div ref={ref} style={{ textAlign: 'center', paddingTop: '10px' }}>
        <img
            style={{ width: '100%', height: 'auto', }}
            src={domain + item.barcodeImage}
            alt={`Barcode for ${item.name}`}
        />
        <b>
            <div style={{ fontWeight: 'bold', fontSize: '54px', marginTop: '5px' }}>
                {item.name || 'No Name'} <br />  <i><span>{item.code || ''}</span></i>
            </div>
        </b>
    </div>

))

export default ComponentToPrint
